import { MessageType } from './../../../constants/constant';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../../services/session.service';
import { ApiService } from '../../../services/api.service';


@Injectable()
export class PopUpService {
    message : string = "";
    config:any ={}
    constructor(private router: Router, private sessionService: SessionService,private api: ApiService) {
        this.config = this.sessionService.get('config')
     }
     showPopup(type, timeout, message, shouldRedirect) {
        try {
            if (this.sessionService.isPlatformServer()) return;
    
            if (type === MessageType.ERROR) {
                this.backendErrorLogging(message).subscribe({
                    next: (res) => console.log(res),
                    error: (err) => console.error("Error logging to backend:", err)
                });
            }
    
            const popupCnt = document.getElementById('popup-cnt');
            const popupMessage = document.getElementById('popup-message');
            const popupComp = document.getElementById('popup-comp');
    
            if(popupComp){
                popupComp.style.display = 'flex';
            }

            if(popupMessage){
                popupMessage.innerText = message;
            }

            if(popupCnt){
                popupCnt.classList.toggle('active');
            }

            this.message = message;
    
            setTimeout(() => {
                this.message = "";
                this.hidePopup();
                if (shouldRedirect) {
                    this.sessionService.removeAll();
                    this.router.navigate(['/welcome']);
                }
            }, timeout || 3500); // Ensure timeout is valid
    
        } catch (error) {
            console.error("Unexpected error in showPopup:", error);
        }
    }
    
    hidePopup() {
        try {
            if (this.sessionService.isPlatformServer()) return;
    
            const popupCnt = document.getElementById('popup-cnt');
            const popupComp = document.getElementById('popup-comp');
            const popupMessage = document.getElementById('popup-message');
            const icon = document.getElementById('pop-icon');
    
            if (icon) {
                icon.classList.remove('ion-alert-circled', 'ion-android-done', 'ion-information-circled');
            }
    
            if (popupCnt) {
                popupCnt.classList.toggle('active');
                popupCnt.classList.remove('success', 'info', 'ion-alert-circled');
            }
    
            if (popupMessage) {
                popupMessage.innerText = '';
            }
    
            if (popupComp) {
                popupComp.style.display = 'none';
            }
    
        } catch (error) {
            console.error("Unexpected error in hidePopup:", error);
        }
    }
    


    backendErrorLogging(msg) {
        const body = {
            marketplace_user_id: this.sessionService.get('config').marketplace_user_id,
            vendor_id: this.sessionService.get('appData') ? this.sessionService.get('appData').vendor_details.vendor_id : undefined,
            error_message: msg,
            app_type: 4,
            customer_side_error: 1,
            screen:window.location.href,
            metadata: JSON.stringify({
                origin_url: window.location.href,
                app_type:'WebApp'
            })
        };
        const obj = {
            'url': 'error/log',
            'body': body,
        };

        return this.api.post(obj);
    }
}
